import SettingHeader from "../SettingHeader";
import Button from "../../../../../common/components/button";
import SelectBox from "../../../../components/common/selectBox";
import Input from "../../../../components/common/input";
import CustomerTable from "./CustomerTable";
import NewCustomer from "./NewCustomer";
import { useGetCustomer } from "../../../../../common/hooks/console/management/customer/useGetCustomer";
import { useEffect, useRef, useState } from "react";
import OtherCustomer from "./OtherCustomer";
import CustomerInfo from "./CustomerInfo";
import { useGetCustomerInfo } from "../../../../../common/hooks/console/management/customer/useGetCustomerInfo";
import Spinner from "../../../../../common/components/spinner";
// import IndividualCus from "./IndividualCus";
import { useAuthStore } from "../../../../store/useAuthStore";
import { useGetCustomerExcel } from "../../../../../common/hooks/console/management/customer/useGetCustomerExcel";

const Customer = () => {
    const level = useAuthStore(state => state.m_level);
    const [excelClick, setExcelClick] = useState<boolean>(false);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(20);
    const [search, setSearch] = useState<string>("customer_name");
    const [searchTxt, setSearchTxt] = useState<string>("");
    const indexRef = useRef<number>(0);
    const storedCustomerIdx = localStorage.getItem("customer_idx");
    const storedCode = localStorage.getItem("code");
    const initialMemberIdx = storedCustomerIdx ? Number(storedCustomerIdx) : 0;
    const [customerIdx, setCustomerIdx] = useState<number>(initialMemberIdx);
    const [code, setCode] = useState<number>(storedCode === "other" ? 2 : initialMemberIdx ? 1 : 0);
    const [customerSpecial, setCustomerSpecial] = useState<boolean>(!initialMemberIdx);
    const [selectedRow, setSelectedRow] = useState<number | null>(initialMemberIdx || null);
    const [field, setField] = useState<string>("customer_name");
    const [direction, setDirection] = useState<"ASC" | "DESC">("ASC");
    const [statusFilter, setStatusFilter] = useState<boolean | null>(null);

    const { data: listData, isLoading: isListLoading } = useGetCustomer(currentPage, pageSize, search, searchTxt, field, direction, statusFilter);
    const { data: infoData } = useGetCustomerInfo(customerIdx);
    const { mutate: downloadCustomerExcel, isPending: isDownloadingExcel } = useGetCustomerExcel(
        () => {
            setExcelClick(false);
        },
        error => {
            console.error("고객 엑셀 다운로드 실패:", error);
            alert("고객 엑셀 다운로드 실패");
            setExcelClick(false);
        },
    );

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handlePageSizeChange = (value: string) => {
        setPageSize(Number(value));
        setCurrentPage(1);
    };

    const handleSort = (newField: string) => {
        setField(prevField => {
            if (prevField === newField) {
                setDirection(prevDirection => (prevDirection === "ASC" ? "DESC" : "ASC"));
                return prevField;
            } else {
                setDirection("ASC");
                return newField;
            }
        });
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTxt]);

    useEffect(() => {
        indexRef.current = customerIdx;
    }, [customerIdx]);

    useEffect(() => {
        if (initialMemberIdx) {
            localStorage.removeItem("customer_idx");
        }
        if (storedCode) {
            localStorage.removeItem("code");
        }
    }, [initialMemberIdx, storedCode]);

    useEffect(() => {
        if ((level === 7 && listData?.data_list?.length) || 0 > 0) {
            const firstCustomer = listData?.data_list[0];
            setCustomerIdx(firstCustomer?.customer_idx || 0);
            setCode(1);
            setCustomerSpecial(true);
            setSelectedRow(firstCustomer?.customer_idx || 0);
        }
    }, [level, listData]);

    useEffect(() => {
        if (excelClick) {
            downloadCustomerExcel();
        }
    }, [excelClick, downloadCustomerExcel]);

    return (
        <div className="flex overflow-hidden h-dvh">
            {(isListLoading || isDownloadingExcel) && <Spinner />}
            <div className="flex flex-col w-full">
                <SettingHeader totalPage={listData?.last_page} currentPage={currentPage} onPageChange={handlePageChange} />
                <div className="flex-1 flex flex-col overflow-hidden">
                    <div className="flex justify-between px-3 py-[15px] items-center border-b border-gray4">
                        <div className="flex gap-1 items-center ">
                            <p className="text-xs">총</p>
                            <button className="text-sm font-bold text-primary2">{listData?.total_count.toLocaleString() || 0}</button>
                        </div>
                        <div className="flex gap-2 items-center">
                            {level === 7 || (
                                <Button onClick={() => setCode(0)} size="S" className="px-2" status="regist">
                                    고객정보 신규등록
                                </Button>
                            )}

                            <SelectBox
                                status="none"
                                className="w-[100px]"
                                options={[
                                    { value: "20", label: "20건씩" },
                                    { value: "50", label: "50건씩" },
                                    { value: "100", label: "100건씩" },
                                ]}
                                value={pageSize.toString()}
                                onChange={handlePageSizeChange}
                            />
                            <div className="w-[240px] flex gap-1">
                                <SelectBox
                                    status="none"
                                    className="min-w-[100px]"
                                    options={[
                                        { value: "customer_name", label: "고객명" },
                                        { value: "manager_name", label: "담당자명" },
                                    ]}
                                    value={search}
                                    onChange={(value: string) => setSearch(value)}
                                />
                                <Input
                                    placeholder="검색"
                                    status="none"
                                    className=""
                                    value={searchTxt}
                                    onChange={e => setSearchTxt(e.target.value)}
                                />
                            </div>
                            <Button
                                onClick={() => {
                                    setExcelClick(true);
                                }}
                                size="S"
                                className="px-2"
                            >
                                엑셀
                            </Button>
                        </div>
                    </div>
                    <div className="flex-1 overflow-y-auto">
                        <CustomerTable
                            data={listData?.data_list}
                            code={code}
                            selectedRow={selectedRow || 0}
                            onRowClick={(code, customerIdx, customerSpecial) => {
                                setCode(code);
                                setCustomerIdx(customerIdx);
                                setCustomerSpecial(customerSpecial);
                                setSelectedRow(customerIdx);
                            }}
                            onSort={handleSort}
                            statusFilter={statusFilter}
                            onStatusFilterChange={value => {
                                setStatusFilter(value);
                                setCurrentPage(1);
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="md:min-w-[620px] min-w-[560px] max-w-[560px] h-dvh overflow-y-auto flex flex-col">
                {code === 1 ? (
                    // customerSpecial ? (
                    //     <IndividualCus data={infoData} id={customerIdx} />
                    // ) : (
                    <CustomerInfo
                        onComplete={id => {
                            if (indexRef.current === id) {
                                setCode(0);
                                setCustomerIdx(0);
                            }
                        }}
                        data={infoData}
                        id={customerIdx}
                    />
                ) : // )
                code === 2 ? (
                    <OtherCustomer
                        key={customerIdx}
                        onComplete={id => {
                            if (id === customerIdx) setCode(0);
                        }}
                        special={customerSpecial}
                        data={infoData}
                        id={customerIdx}
                    />
                ) : (
                    <NewCustomer
                        onCustomerCreated={(customerIdx, type) => {
                            setSelectedRow(customerIdx);
                            setCustomerIdx(customerIdx);
                            type === "customer" && setCode(1);
                            type === "customer" && setCustomerSpecial(false);
                            type === "other" && setCode(2);
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default Customer;
